import React from 'react';
import styled from 'styled-components';

const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 20px 0;
`;

const SearchInput = styled.input`
  flex: 1;
  max-width: 400px;
  padding: 14px 20px;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 400;
  font-size: 14px;
  background-color: #ffffff;
  transition: all 0.2s ease;
  
  &::placeholder {
    color: #6B6B6B;
  }

  &:focus {
    outline: none;
    border-color: #D2691E;
    box-shadow: 0 0 0 3px rgba(210, 105, 30, 0.1);
    background-color: #FFF8F2;
  }
`;

const SearchBar = ({ placeholder, value, onChange, onKeyPress, ...props }) => {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && onKeyPress) {
      onKeyPress(e);
    }
  };

  return (
    <SearchContainer>
      <SearchInput
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onKeyPress={handleKeyPress}
        {...props}
      />
    </SearchContainer>
  );
};

export default SearchBar;
